<div>
  <div class="modal-header">
    <h4 class="modal-title" translate>page.controles.manquement.recours.modale.title</h4>
  </div>
  <div class="modal-body">
    <span translate>page.controles.manquement.recours.modale.message</span>
    <!-- Boutons d'action -->
    <div class="actions-bar mt-3">
      <button type="submit" class="btn btn-primary ms-2" (click)="onTerminer()" translate>label.fermer</button>
    </div>
  </div>
</div>
